import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";
import { services } from "../services/notificationService";

let savedApprovalSetting;
function init() {
    savedApprovalSetting = $("#selectApprovalSettings").val();
    $(".m-collapse").click(toggleHideShow);
    $("#btnSubmitApprovalSetting").click(setApprovalSetting);
    $("#selectApprovalSettings").change(function() {
        if (savedApprovalSetting !== $("#selectApprovalSettings").val())
            toggleApprovalSettingsSubmit(true);
        else
            toggleApprovalSettingsSubmit(false);
    });
}

function toggleHideShow(e, target) {
    $(this).parent().find(".m-collapse, .hidden").removeClass("hidden");
    $(this).addClass("hidden");
}

function setApprovalSetting() {
    toggleApprovalSettingsSubmit(false);
    toggleApprovalSettingSelect(false);
    dataaccess.put({
        url: "Person/ApprovalSetting/" + $("#selectApprovalSettings").val()
    }).done(function() {
        savedApprovalSetting = $("#selectApprovalSettings").val();
        services.notificationService.success("Successfully changed Approval Setting.");
        toggleApprovalSettingSelect(true);
    }).fail(function() {
        toggleApprovalSettingSelect(true);
    });
}
function toggleApprovalSettingsSubmit(enabled) {
    enabled ? $("#btnSubmitApprovalSetting").removeAttr("disabled") : $("#btnSubmitApprovalSetting").attr("disabled", "disabled");
}
function toggleApprovalSettingSelect(enabled) {
    enabled ? $("#selectApprovalSettings").removeAttr("disabled") : $("#selectApprovalSettings").attr("disabled", "disabled");
}

export const dashboardTodo = {
    init: init
};